import { generateUrlParams } from '../../utils/generateUrlParams';
import { apiAuth, apiPublic } from '../../utils/hooks';

const getProjects = (filters) => {
    if (filters) {
        filters.minPrice = Number(filters.minPrice)
            ? filters.minPrice * 100
            : filters.minPrice;
        filters.maxPrice = Number(filters.maxPrice)
            ? filters.maxPrice * 100
            : filters.maxPrice;

        const params = generateUrlParams(filters);

        return apiAuth()
            .get(`/carbon/projects?${params}`)
            .then((data) => data)
            .catch((error) => {
                throw error;
            });
    }

    return apiAuth()
        .get(`/carbon/projects`)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const getProjectById = (id) => {
    return apiAuth()
        .get(`/carbon/projects/${id}`)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const addProject = (params) => {
    return apiAuth()
        .post('/carbon/user-projects', params)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const getUserProjects = (userId) => {
    return apiPublic()
        .get(`/carbon/public/projects?idUser=${userId}`)

        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const getStatByProject = (projectId) => {
    return apiAuth()
        .get(`/carbon/statistics/global-project-stats?ids=${projectId}`)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const replaceFavorite = (id) => {
    return apiAuth()
        .put(`/carbon/user-projects/${id}`, { isDefault: '1' })
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const deleteUserProject = (id) => {
    return apiAuth()
        .delete(`/carbon/user-projects/${id}`)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

export const getSustainableGoals = () => {
    return apiAuth()
        .get(`/sustainable-development-goals`)
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

export const updateOdd = (idProject, sdgId) => {
    return apiAuth()
        .patch(`/carbon/user-projects/${idProject}`, { selectedSDG: sdgId })
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

export {
    getProjects,
    getUserProjects,
    deleteUserProject,
    addProject,
    getProjectById,
    replaceFavorite,
    getStatByProject,
};
